import CreditCardIcon from "@mui/icons-material/CreditCard";

import PixIcon from "@mui/icons-material/Pix";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { CheckIcon } from "src/Pages/components/Icons/Icons";
import { Box, SxProps, Theme, Typography } from "@mui/material";

interface ICompChipsStatusPayment {
  backgroundColor?: string;
  color?: string;
  icon: React.ReactNode;
  label?: string;
  size?: "small" | "medium";
  sxStyle?: SxProps<Theme>;
}

export const CompChipsStatusPayment = ({
  backgroundColor,
  color,
  icon,
  label,
  size = "small",
  sxStyle,
}: ICompChipsStatusPayment) => {
  const sizeFont = {
    small: "12px",
    medium: "14px",
  };

  return (
    <Box
      sx={{
        backgroundColor,
        borderRadius: "8px",
        color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px",

        ...sxStyle,
      }}
    >
      {icon}
      {label && (
        <Typography sx={{ fontSize: sizeFont[size], fontWeight: "bold" }}>
          {label}
        </Typography>
      )}
    </Box>
  );
};

export const colorStatusDueDate = (dueDate: string, payment: boolean) => {
  const dateDueDate = new Date(dueDate);
  const today = new Date();

  if (payment) {
    return "inherit";
  }

  if (dateDueDate < today && !payment) {
    return "red";
  }
  if (dateDueDate > today && !payment) {
    return "orange";
  }

  return "inherit";
};

export const ObjMethodPayment = {
  CREDIT_CARD: {
    icon: <CreditCardIcon fontSize="small" color="success" />,
    label: "Cartão de crédito",
  },
  PIX: {
    icon: <PixIcon fontSize="small" color="success" />,
    label: "Pix",
  },
  NOT_DEFINED: {
    icon: <></>,
    label: "",
  },
};

export const objStatusPayment = {
  CONFIRMED: {
    icon: <CheckIcon color="success" />,
    label: "Pago",
    color: "success",
  },
  PENDING: {
    icon: <AccessTimeIcon color="warning" fontSize="small" />,
    label: "Aguardando",
    color: "warning",
  },
};
